var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { getDeliveryLocationsIfExists } from '../components/ShippingConfiguration/shippingConfigUtil';
import { getProductDetails } from '../components/ShippingConfiguration/services/introduction.js';
import { getFulfillmentLocationInfo } from '../components/ShippingConfiguration/services/fulfillementLocations';
import { ACTION_PRICING_GRID_COMPONENT as actionTypes } from '../utils/constants';
import { getProductionTime, getShippingConfiguration } from '../services/shippingutil';
import { currencyCodes, getFiscalYear, getTabConfiguration, setTabConfiguration, getTabIndexFromKey, getKeyFromTabIndex } from '../utils/utils';
import { convertCurrency } from '../services/currency';
export var loadBudgetRates = function loadBudgetRates() {
  return function (dispatch) {
    var fiscalYear = getFiscalYear();
    var results = currencyCodes.map(function (obj) {
      var fromCurrency = obj.symbol;
      return currencyCodes.map(function (_a) {
        var toCurrency = _a.symbol;
        var result = {
          fromCurrency: fromCurrency,
          toCurrency: toCurrency,
          rate: null
        };
        return convertCurrency(fromCurrency, toCurrency, fiscalYear).then(function (res) {
          if (res && res.rate) {
            result.rate = res.rate;
          }

          return result;
        }).catch(function () {
          return result;
        });
      });
    }).flat();
    return Promise.all(results).then(function (results1) {
      dispatch({
        type: actionTypes.SAVE_BUDGET_RATES,
        payload: results1
      });
    });
  };
};
export var loadPricingGridData = function loadPricingGridData(pricingGridProps) {
  return {
    type: actionTypes.LOAD_PRICING_GRID_DATA,
    payload: pricingGridProps
  };
};
export var clearState = function clearState() {
  return {
    type: actionTypes.CLEAR_STATE
  };
};

var saveDeliveryLocations = function saveDeliveryLocations(deliveryLocations) {
  return {
    type: actionTypes.SAVE_DELIVERY_LOCATIONS,
    payload: deliveryLocations
  };
};

export var setDeliveryLocations = function setDeliveryLocations(skuData) {
  return function (dispatch) {
    var sku = Object.keys(skuData)[0];
    return getDeliveryLocationsIfExists(sku).then(function (deliveryLocations) {
      return dispatch(saveDeliveryLocations(deliveryLocations));
    });
  };
};

var saveProductionTime = function saveProductionTime(productionTimeData) {
  return {
    type: actionTypes.SAVE_PRODUCTION_TIME,
    payload: productionTimeData
  };
};

export var setSkuProductionTime = function setSkuProductionTime(skuData) {
  return function (dispatch) {
    var sku = Object.keys(skuData)[0];

    if (sku) {
      return getProductionTime(sku).then(function (response) {
        return dispatch(saveProductionTime(response));
      }).catch(function () {
        return dispatch(saveProductionTime(null));
      });
    }

    return null;
  };
};

var saveFulfillmentLocations = function saveFulfillmentLocations(fulfillmentLocations) {
  return {
    type: actionTypes.SAVE_FULFILLMENT_LOCATIONS,
    payload: fulfillmentLocations
  };
};

export var saveShippingConfig = function saveShippingConfig(shippingConfiguration) {
  return {
    type: actionTypes.SAVE_SHIPPING_CONFIGURATION,
    payload: shippingConfiguration
  };
};

var toggleSaveShippingConfig = function toggleSaveShippingConfig(isSaveShippingEnabled) {
  return {
    type: actionTypes.TOGGLE_SAVE_SHIPPING_CONFIG,
    payload: isSaveShippingEnabled
  };
};

export var setFulfillmentLocations = function setFulfillmentLocations(skuData) {
  return function (dispatch) {
    var mcpSku = Object.keys(skuData)[0];

    if (mcpSku) {
      return getProductDetails(mcpSku).then(function (productDetails) {
        if (!productDetails) {
          dispatch(saveFulfillmentLocations({}));
          return null;
        }

        var fulfillmentLocations = productDetails.fulfillmentLocations;
        var promises = fulfillmentLocations.map(function (fulfillmentLocation) {
          return getFulfillmentLocationInfo(fulfillmentLocation.externalFulfillmentLocationId);
        });
        var fulfillerInformation = [];
        return Promise.all(promises).then(function (results) {
          fulfillerInformation = results.map(function (result) {
            var fulfillmentObject = {
              fulfillmentLocationName: result.name,
              fulfillmentLocationId: result.fulfillmentLocationId
            };
            return fulfillmentObject;
          });
          dispatch(saveFulfillmentLocations(fulfillerInformation));
        });
      });
    }

    return null;
  };
};
export var setShippingConfiguration = function setShippingConfiguration(shippingConfiguration) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var savedConfig;
      return __generator(this, function (_a) {
        if (shippingConfiguration) {
          return [2
          /*return*/
          , dispatch(saveShippingConfig(shippingConfiguration))];
        }

        savedConfig = getState().pricingGrid.shippingConfiguration;

        if (!savedConfig) {
          return [2
          /*return*/
          , getShippingConfiguration().then(function (shippingConfig) {
            if (shippingConfig) {
              dispatch(saveShippingConfig(shippingConfig));
              dispatch(toggleSaveShippingConfig(true));
            }
          })];
        }

        return [2
        /*return*/
        , null];
      });
    });
  };
};
export var getSelectedTabConfiguration = function getSelectedTabConfiguration(selectedTab) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (selectedTab) {
          return [2
          /*return*/
          , dispatch(setSelectedTab(getTabIndexFromKey(selectedTab)))];
        }

        return [2
        /*return*/
        , getTabConfiguration().then(function (selectedTabCustomizr) {
          dispatch(setSelectedTab(getTabIndexFromKey(selectedTabCustomizr)));
        }).catch(function () {
          dispatch(setSelectedTab(0));
        })];
      });
    });
  };
};
export var setSelectedTabConfiguration = function setSelectedTabConfiguration(selectedTab) {
  return function (dispatch) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setTabConfiguration(getKeyFromTabIndex(selectedTab));
        dispatch(setSelectedTab(selectedTab));
        return [2
        /*return*/
        ];
      });
    });
  };
};
export var setSelectedTab = function setSelectedTab(selectedTab) {
  return {
    type: actionTypes.SET_SELECTED_TAB,
    payload: selectedTab
  };
};
export var setLogger = function setLogger(logger) {
  return {
    type: actionTypes.SAVE_LOGGER,
    payload: logger
  };
};
export var onShippingSubmit = function onShippingSubmit(destinationCountryCode, destinationPostalCode, shippingTime, city, fulfillmentLocation, isSaveShippingEnabled) {
  return {
    type: actionTypes.ON_SHIPPING_SUBMIT,
    payload: {
      destinationCountryCode: destinationCountryCode,
      destinationPostalCode: destinationPostalCode,
      shippingTime: shippingTime,
      isSaveShippingEnabled: isSaveShippingEnabled,
      city: city,
      fulfillmentLocation: fulfillmentLocation
    }
  };
};